import { Component, Input, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../../import/services/translation.service';
import { DataAdministrationService } from '../../data-administration/services/data-administration-service';
import { ImportService } from '../../import/services/import.service';
import { baseHOST } from '../../routes';
import { CharacteristicSpecificationComponent } from '../characteristic-specification/characteristic-specification.component';

@Component({
  selector: 'app-detail-comparison',
  templateUrl: './detail-comparison.component.html',
  styleUrls: ['./detail-comparison.component.scss']
})
export class DetailComparisonComponent implements OnInit {

	@Input() entityType: string;
	@Input() entity: Object = {};
	@Input() existingEntityId: string;
	@Input() referencedCandidates: Object = {};

	candidates = [];
	backUpEntity: Object = {};
	entityType_single_translated: string;
	loadingDetails: boolean = true;
	loadingForm: boolean = true;
	showOptionalFields: boolean = true;
	formModel: Object = {};
	formEntity = new FormGroup({});
	buttonLocked: boolean = false;

	public tools: object = {
        items: ['Undo', 'Redo', '|',
            'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
            'SubScript', 'SuperScript', '|',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
            'Indent', 'Outdent', '|', 'CreateLink',
            'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
    };
    public quickTools: object = {
        image: [
            'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', '-', 'Display', 'AltText', 'Dimension']
    };

	constructor(private dataAdministrationService: DataAdministrationService, private importService: ImportService, public activeModal: NgbActiveModal, private modalService: NgbModal, private toastManager: ToastrService, private translate: TranslateService, private translationService: TranslationService) { }

	ngOnInit() {
		this.entityType = this.translationService.convertEntityType(this.entityType);
		this.translate.get('data_administration.entities.' + this.entityType + ".single").subscribe((res: string) => { this.entityType_single_translated = res; });
		this.dataAdministrationService.getForm(this.entityType, 'POST', null).subscribe(formFields => {
			this.formModel['form_fields'] = formFields;
			var self = this;
			Object.keys(this.entity).forEach(function(key) {
				var value = self.entity[key];
				var formField = self.formModel['form_fields'].filter(formField => formField['snake_case'] === key)[0];
				if (typeof value === 'object' && value !== null) {
					if (Array.isArray(value)) {
						self.entity[key] = [];
						value.forEach(function(elem) {
							if (typeof elem === 'object' && elem != null) {
								if (elem['id'] !== undefined) self.entity[key].push(elem['id']);
							} else self.entity[key].push({'value': elem, 'display': elem});
						});
					} else if (value['id'] !== undefined) {
						self.entity[key] = value['id'];
					}
				} else {
					self.entity[key] = value;
				}
	
				if (value !== null && value !== undefined && (formField && (formField['data_type'] == 'date' || formField['data_type'] == 'datetime'))) {
					value = DateTime.fromISO(value).toISODate();
					self.entity[key] = value;
				}
			});
			this.formModel['form_fields'].forEach(function (formField) {
				formField['upload_download'] = 'upload';
				
				// get tooltip
				var tooltipTranslationKey = 'data_administration.entities.' + self.entityType + '.tooltips.' + formField['snake_case'];
				self.translate.get(tooltipTranslationKey).subscribe((res: string) => {
						if (res !== tooltipTranslationKey) formField['tooltip'] = res;
					});

				if (formField.data_type == 'select') {
					formField['loading'] = true;
					if (self.candidates[formField.target_entity] === undefined) {
						self.dataAdministrationService.loadAllCandidates(formField.target_entity, formField.internal_field_name).subscribe(
							response => {
								var filteredResponse = response.filter(candidate => candidate.name !== undefined);
								formField['candidates'] = [];
								filteredResponse.forEach(function (candidate) {
										formField['candidates'].push({value: candidate.id, label: candidate.name});
								});
								self.candidates[formField.target_entity] = formField['candidates'];
								formField['loading'] = false;
							});
					} else {
						formField['candidates'] = self.candidates[formField.target_entity];
						formField['loading'] = false;
					}	
				} else if ((self.entity[formField['snake_case']] == undefined || self.entity[formField['snake_case']] == null) && formField['default_value'] !== undefined) {
					self.entity[formField['snake_case']] = formField['default_value'];
				}

				var validators = [];
				if (formField['not_null'] === true) validators.push(Validators.required);
				if (formField['email'] === true) validators.push(Validators.email);
				var formControl = new FormControl();
				formControl.setValidators(validators);
				self.formEntity.addControl(formField['snake_case'], formControl);
			});
			
			this.loadingForm = false;
			this.dataAdministrationService.getEntity('administration', this.entityType, this.existingEntityId).subscribe(response => {
				console.log(response);
				var self = this;
				Object.keys(response).forEach(function(key) {
					var value = response[key];
					var formField = self.formModel['form_fields'].filter(formField => formField['snake_case'] === key)[0];
					var associatedFormFields = self.formModel['form_fields'].filter(formField => formField['snake_case'].includes(key + ' - '));

					if (associatedFormFields.length === 0) {
						if (!self.formEntity.get(key)) self.formEntity.addControl(key, new FormControl());
						if (typeof value === 'object' && value !== null) {
							if (Array.isArray(value)) {
								var arrayValue = [];
								value.forEach(function(elem) {
									if (typeof elem === 'object' && elem != null && !key.includes('characteristic_specifications')) {
										if (elem['id'] !== undefined) {
											arrayValue.push(elem['id']);
										}
									} else {
										if (key.includes('characteristic_specifications')) arrayValue.push({'value': elem['id'], 'display': elem['characteristic']['name']});
										else arrayValue.push(elem);
									}
								});

								self.formEntity.get(key).patchValue(arrayValue);
							} else if (value['id'] !== undefined) {
								self.formEntity.get(key).patchValue(value['id']);
							}
						} else {
							self.formEntity.get(key).patchValue(value);
						}

						if (formField) {
							if (formField['file'] !== undefined) {
								formField['path'] = self.getAbsolutePath(value);
							} else if (value !== null && value !== undefined && (formField['data_type'] == 'date' || formField['data_type'] == 'datetime')) {
								value = DateTime.fromISO(value).toISODate();
								self.formEntity.get(key).patchValue(value);
							}
						}
					} else if (typeof value === 'object' && value !== null) {
						Object.keys(value).forEach(function (referencedKey) {
							var referencedValue = value[referencedKey];
							var fullKey = key + ' - ' + referencedKey;
							if (!self.formEntity.get(fullKey)) self.formEntity.addControl(fullKey, new FormControl());
							if (typeof referencedValue === 'object' && referencedValue !== null) {
								if (Array.isArray(referencedValue)) {
									var arrayValue = [];
									referencedValue.forEach(function(elem) {
										if (typeof elem === 'object' && elem != null && referencedKey !== 'characteristic_specifications') {
											if (elem['id'] !== undefined) arrayValue.push(elem['id']);
										} else {
												if (fullKey === 'characteristic_specifications') arrayValue.push({'value': elem['id'], 'display': elem['characteristic']['name']});
												else arrayValue.push(elem);
										}
									});

									self.formEntity.get(fullKey).patchValue(arrayValue);
								} else if (referencedValue['id'] !== undefined) {
									self.formEntity.get(fullKey).patchValue(referencedValue['id']);
								}
							} else {
								self.formEntity.get(fullKey).patchValue(referencedValue);
							}
						});
					}	
				});
				this.backUpEntity = {...this.formEntity.value};
				this.loadingDetails = false;
			}, err => {
				this.translate.get('import.profile.errors.detailed_comparison_not_loaded').subscribe((res: string) => {
					this.toastManager.error(res);
					this.loadingForm = false;
					this.loadingDetails = false;
					this.activeModal.close();
				});
		 	});
		}, err => {
			this.translate.get('data_administration.errors.load_form').subscribe((res: string) => {
				this.toastManager.error(res);
				this.loadingForm = false;
				this.activeModal.close();
			});
		});
	}

	onSelectCharacteristicSpecification(obj, formField) {
		var id = obj['value'];
		const modalRef = this.modalService.open(CharacteristicSpecificationComponent, {size: 'lg'});
		modalRef.componentInstance.mode = 'edit';
		var entityType = this.entityType;
		if (formField['host_entity_type']) entityType = formField['host_entity_type'];
		modalRef.componentInstance.entityType = entityType;
		modalRef.componentInstance.hostEntity = this.formEntity.value;
		modalRef.componentInstance.characteristicSpecificationId = id;
	}

	showTransferButton(formField) {
		if (this.entity !== undefined && this.entity[formField['snake_case']] && this.entity[formField['snake_case']] !== null) {
			if (Array.isArray(this.entity[formField['snake_case']])) {
				if (this.entity[formField['snake_case']].length === 0) return false;
				if (this.entity[formField['snake_case']].length !== this.formEntity.get(formField['snake_case']).value.length) return true;
				
				for (var i = 0; i < this.entity[formField['snake_case']].length; i++) {
					if (this.entity[formField['snake_case']][i]['value'] !== this.formEntity.get(formField['snake_case']).value[i]) return true;
				}
			} else {
				return this.entity[formField['snake_case']] !== this.formEntity.get(formField['snake_case']).value;
			}
		}

		return false;
	}

	undo(formField) {
		this.formEntity.get(formField['snake_case']).patchValue(this.backUpEntity[formField['snake_case']]);
	}

	transferValue(formField) {
		this.formEntity.get(formField['snake_case']).patchValue(this.entity[formField['snake_case']]);
	}

	saveEntity() {
		this.buttonLocked = true;
		var self = this;
		this.dataAdministrationService.updateEntity(null, this.entityType, this.formEntity.value, this.formModel['form_fields']).subscribe(
			response => {
				const results = this.formModel['form_fields'].filter(formField => formField['file'] == true && formField['upload_download'] == 'upload');
				results.forEach(function (formField) {
				self.dataAdministrationService.handleFile(null, self.entityType, response['id'], formField['snake_case'], formField['internal_field_name'], self.formEntity.get(formField['snake_case']).value).subscribe(
						response => {
							console.log(response);
						}, err => {
							self.translate.get('data_administration.errors.file_upload').subscribe((res: string) => { self.toastManager.error(res); });
						});
				});
				self.importService.loadAllCandidates(this.entityType, null).subscribe(candidatesResponse => {
					this.referencedCandidates[this.entityType] = [];
					var filteredResponse = candidatesResponse.filter(candidate => candidate.name !== undefined);
					filteredResponse.forEach(function(candidate) {
						self.referencedCandidates[self.entityType].push({value: candidate['id'], label: candidate['name']});
					});
					this.translate.get('data_administration.success.update',  {entityType: this.entityType_single_translated})
					.subscribe((res: string) => {
						this.toastManager.success(res);
						this.activeModal.close();
					});
				}, err => {
					this.referencedCandidates[this.entityType] = [];
					this.referencedCandidates[this.entityType].push({value: response['id'], label: ''});
					this.translate.get('data_administration.success.update',  {entityType: this.entityType_single_translated})
					.subscribe((res: string) => {
						this.toastManager.success(res);
						this.activeModal.close();
					});
				});
			}, err => {
				this.buttonLocked = false;
				this.translate.get('data_administration.errors.update',  {entityType: this.entityType_single_translated})
				.subscribe((res: string) => { this.toastManager.error(res); });  
			}
		);
	}

	cancel() {
		this.activeModal.close();
	}

	onFileChange(event, formField) {
		if (event.target.files.length > 0) {
			var file = event.target.files[0];
			if (formField['max_size'] === undefined || file.size <= formField['max_size']) {
				this.entity[formField['snake_case']] = event.target.files[0];
				this.preview(event.target.files, formField);
			} else {
				event.target.value = '';
				this.translate.get('data_administration.errors.file_too_large').subscribe((res: string) => {
					this.toastManager.error(res);
				});
			}
		}
	}

	getAbsolutePath(path) {
		if (path !== undefined && path !== null) {

			var r = new RegExp('^(?:[a-z]+:)?//', 'i');

			if (r.test(path)) { // absolute path
				return path;
			} else {
				return baseHOST + path;
			}
		};

		return null;
	}

	preview(files, formField) {
		if (files.length === 0)
		  return;
	 
		if (files[0].type.startsWith('image')) {
			var reader = new FileReader();
			reader.readAsDataURL(files[0]); 
			reader.onload = (_event) => { 
			formField['path'] = reader.result; 
			}
		} else {
			return;
		}
	}

	removeFile(event, formField) {
		document.getElementsByName(formField['snake_case'])[0]['value'] = '';
		this.entity[formField['snake_case']] = null;
		formField['path'] = null;
	}

	getReferencedFieldString(formField) {
		var hostEntityTypeParts = formField['host_entity_type'].split('\\');
		var hostEntityType = hostEntityTypeParts[hostEntityTypeParts.length - 1];
		var fieldNameParts = formField['snake_case'].split(' - ');
		var fieldName = fieldNameParts[fieldNameParts.length - 1];
		var result = 'data_administration.entities.' + hostEntityType.charAt(0).toLowerCase() + hostEntityType.slice(1) + '.properties.' + fieldName;
		console.log(result);
		return result;
	}
}
